import Vue from 'vue'
import Vuex from 'vuex'
import {baseURL} from '../utils/contract'
Vue.use(Vuex)
const state = {
  fileUrl:`${baseURL}/materials/`,//文件路径
}
const mutations = {
  setMutations (state, data) {
    let keys = Object.keys(data)
    keys.map(item => {
      state[item] = data[item]
    })
    // console.log(state['gridMonitorLoading'])
  },
  setFileUrl(state, data) {
    state.fileUrl = data
  }
} 
const actions = {
  // 首页-头部
  
  


}
export default new Vuex.Store({
  state,
  mutations,
  actions
})